// import axios from "axios";
import axios from '../libs/axios'

const baseURL = "/api/admin/";
const prepaidBaseURL = "/api/prepaid/";

export default {
  getUsers(limit) {
    return axios.get(baseURL + `users?limit=${limit}`);
  },
  updateUserSubscription(username, newSubDate) {
    return axios.post(baseURL + `user/${username}/subscription`, {
      newSubDate: newSubDate
    });
  },
  updateUser(username, name, password) {
    return axios.patch(baseURL + `user/${username}`, {
      name: name,
      password: password,
    });
  },
  createUser(user) {
    return axios.post(baseURL + "user/", { ...user });
  },
  deleteUser(username) {
    return axios.delete(baseURL + `user/${username}`);
  },
  updateUserAiLimit(username, aiLimit) {
    return axios.post(baseURL + `user/${username}/ai-limit`, {
      aiLimit: aiLimit
    });
  },
  updateUserAccountType(username, accountType) {
    return axios.post(baseURL + `user/${username}/account-type`, {
      accountType: accountType
    });
  },
  updateUserType(username, userType) {
    return axios.post(baseURL + `user/${username}/user-type`, {
      userType: userType
    });
  },
  getOrgInfo(username) {
    return axios.get(baseURL + `user/${username}/org-info`);
  },
  updateOrgInfo(username, filters) {
    return axios.post(baseURL + `user/${username}/org-info`, filters);
  },
  // Distributor CRUD
  getDistributors() {
    return axios.get(baseURL + 'distributors');
  },
  createDistributor(name, description) {
    return axios.post(baseURL + 'distributors', { name: name, description: description || '' });
  },
  deleteDistributor(id) {
    return axios.delete(baseURL + `distributors/${id}`);
  },
  // HQ CRUD
  getHqs() {
    return axios.get(baseURL + 'hqs');
  },
  createHq(name, description) {
    return axios.post(baseURL + 'hqs', { name: name, description: description || '' });
  },
  deleteHq(id) {
    return axios.delete(baseURL + `hqs/${id}`);
  },
  // User Dataset Management
  getUserDatasets(username) {
    return axios.get(baseURL + `user/${username}/datasets`);
  },
  createUserDataset(username, examType) {
    return axios.post(baseURL + `user/${username}/datasets`, { exam_type: examType });
  },
  deleteUserDataset(username, datasetId) {
    return axios.delete(baseURL + `user/${username}/datasets/${datasetId}`);
  },
  // Grouped Datasets (for sharing)
  getGroupedDatasets() {
    return axios.get(baseURL + 'datasets/grouped');
  },
  // ----- Prepaid credit operator API (/api/prepaid/) -----
  getPrepaidBalance(username, institution) {
    return axios.get(prepaidBaseURL + `${username}/balance`, {
      params: institution ? { institution: institution } : {}
    });
  },
  getPrepaidPreview(username, institution) {
    return axios.get(prepaidBaseURL + `${username}/preview`, {
      params: institution ? { institution: institution } : {}
    });
  },
  getPrepaidLedger(username, institution) {
    return axios.get(prepaidBaseURL + `${username}/ledger`, {
      params: institution ? { institution: institution } : {}
    });
  },
  grantPrepaid(username, payload) {
    return axios.post(prepaidBaseURL + `${username}/grant`, { ...payload });
  },
  revokePrepaid(username, payload) {
    return axios.post(prepaidBaseURL + `${username}/revoke`, { ...payload });
  },
  listPrepaidAccounts() {
    return axios.get(prepaidBaseURL + 'accounts');
  },
  getPrepaidWallets(username) {
    return axios.get(prepaidBaseURL + `${username}/wallets`);
  },
  createPrepaidWallet(username, institution) {
    return axios.post(prepaidBaseURL + `${username}/wallets`, { institution: institution });
  },
  updatePrepaidLotExpiry(username, lotId, payload) {
    return axios.post(prepaidBaseURL + `${username}/lot/${lotId}/expiry`, { ...payload });
  }
};
